<template>
  <v-app :dark="dark">
    <vue-progress-bar>
    </vue-progress-bar>
    <template v-if="!loggedIn">
      <router-view :dark="dark"></router-view>
    </template>
    <template v-if="loggedIn">
      <v-navigation-drawer  :dark="dark" :class="dark ? '' : 'blue lighten-5'" width="250" light :mini-variant.sync="mini" v-model="drawer" app>
        <!-- mini-variant.sync="true" -->
        <v-list class="pa-0">
          <v-list-tile avatar tag="div">
            <v-list-tile-avatar>
              <img src="/assets/img/logo.png">
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title>{{account_info.nick_name}}</v-list-tile-title>
            </v-list-tile-content>
            <v-spacer></v-spacer>
            <v-list-tile-action style="min-width:30px;">
              <v-menu bottom right offset-y origin="bottom right" transition="v-slide-y-transition">
                <v-btn icon light slot="activator">
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list>
                  <v-list-tile v-for="item in userMenus" :key="item.title" value="true" :to="item.link" router>
                    <v-list-tile-title v-text="item.title"></v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>

            </v-list-tile-action>
            <v-list-tile-action style="min-width:30px;">
              <v-btn icon @click.native.stop="mini = !mini">
                <v-icon>chevron_left</v-icon>
              </v-btn>
            </v-list-tile-action>
          </v-list-tile>

        </v-list>
        <v-list>
          <v-list-tile v-for="item in items" :key="item.title" @click="clickMenu(item)" router>
            <v-list-tile-action class="pr-1 pl-2 mr-1">
              <v-icon :class="activeMenuItem.includes(item.title)?'blue--text': ''" :title="item.title" light v-html="item.icon"></v-icon>
            </v-list-tile-action>
            <v-list-tile-content :class="activeMenuItem.includes(item.title)?'blue--text': ''">
              <v-list-tile-title v-text="item.title"></v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-navigation-drawer>


      <v-toolbar app>
      <!--v-toolbar app height="100px"-->
        <v-toolbar-side-icon @click.native.stop="drawer = !drawer" light></v-toolbar-side-icon>
          <v-menu v-if="showFilters()" lazy :close-on-content-click="true" transition="v-scale-transition" offset-y full-width
            :nudge-left="40" max-width="290px">
            <v-text-field class="mt-3 mb-6 right-input" slot="activator" label="От:" v-model="fromRu" prepend-icon="event" readonly></v-text-field>
            <v-date-picker v-model="from" no-title scrollable autoclose :locale="'ru-RU'">
            </v-date-picker>
          </v-menu>
          &nbsp;<v-text-field v-if="showFilters()" class="mt-3 mb-6 right-input" style="max-width: 80px;" type="time" v-model="fromTime"></v-text-field>
          &nbsp;&nbsp;&nbsp;&nbsp;
          <v-menu v-if="showFilters()" lazy :close-on-content-click="true" transition="v-scale-transition" offset-y full-width
            :nudge-left="40" max-width="290px">
            <v-text-field class="mt-3 mb-6 right-input" slot="activator" label="До:" v-model="untilRu" readonly></v-text-field>
            <v-date-picker v-model="until" no-title scrollable autoclose :locale="'ru-RU'">
            </v-date-picker>
          </v-menu>
          &nbsp;<v-text-field v-if="showFilters()" class="mt-3 mb-6 right-input" style="max-width: 80px;" type="time" v-model="untilTime"></v-text-field>
          &nbsp;&nbsp;&nbsp;&nbsp;
        <v-select v-if="showFilters() && $route.path != '/orders'" class="mt-3 mb-6 select-box" v-bind:items="workers" label="Сотрудник" style="max-width: 130px;" v-model="worker" clearable>
          <template slot="selection" slot-scope="workers">
            {{ workers.item.nick_name }} 
          </template>
          <template slot="item" slot-scope="workers">
            {{ workers.item.nick_name }} 
          </template>
        </v-select>
        &nbsp;&nbsp;&nbsp;&nbsp;
        <v-select v-if="$route.path === '/pdfchecks'" class="mt-3 mb-6 select-box" v-bind:items="banks" label="Банк" v-model="bank" clearable>
          <template slot="selection" slot-scope="banks">
            {{ banks.item.name }} 
          </template>
          <template slot="item" slot-scope="banks">
            {{ banks.item.name }} 
          </template>
        </v-select>

        <v-select v-if="$route.path == '/orders'" class="mt-3 mb-6 select-box" style="max-width: 250px;" v-bind:items="accounts" label="Аккаунт" v-model="account" clearable>
          <template slot="selection" slot-scope="accounts">
            {{ accounts.item.account_name }} 
          </template>
          <template slot="item" slot-scope="accounts">
            {{ accounts.item.account_name }} 
          </template>
          
        </v-select>
        <v-spacer></v-spacer>

        <!--div class="text-xs-center pr-3">
        </div-->
        <!--v-btn light flat  href="https://bankpdf.ru/" target="_blank"-->
            <!--img src="/assets/img/logo.jpg" height="45" class="octicon octicon-mark-github" version="1.1" width="92" aria-hidden="true"-->
            <table>
              <tr><td>
                <span style="margin-left:0.4rem;">Оплачено до: </span>
                <span style="margin-left:0.4rem; font-size: 18px;">{{ account_info.paid_until }} </span>
              </td></tr>
              <tr><td>
                <span v-if="account_info.paid_count > -2" style="margin-left:0.4rem;">Остаток проверок: </span>
                <span v-if="account_info.paid_count < -1" style="margin-left:0.4rem;">Оплачено аккаунтов: </span>
                <span v-if="account_info.paid_count > -1" style="margin-left:0.4rem; font-size: 18px;">{{ account_info.paid_count }} </span>
                <span v-if="account_info.paid_count == -1" style="margin-left:0.4rem; font-size: 18px;">∞</span>
                <span v-if="account_info.paid_count < -1" style="margin-left:0.4rem;">{{ account_info.paid_count * -1 }}</span>
              </td></tr>
            </table>
          <!--/v-btn-->
        <v-btn icon @click.native.stop="darkMode()">
          <v-icon>wb_sunny</v-icon>
        </v-btn>
      </v-toolbar>
      <v-content>
        <v-container fluid >
          <!-- <v-layout>
            <v-flex row=""> -->
              <router-view :dark="dark"></router-view>
            <!-- </v-flex>
          </v-layout> -->
        </v-container>
      </v-content>
      <!-- <canvas id="canvas"></canvas> -->
      <v-footer :inset="true" style="justify-content:center; text-align: center" app>
        <span>&copy; BankPDF-CRM 2025</span>
      </v-footer>
    </template>
  </v-app>

</template>
<script>
/* globals Store */
  import auth from "./utils/auth";
  import { mapState } from "vuex";

  export default {
    data () {
      return {
        dialog: false,
        mini: false,
        dialogText: "",
        dialogTitle: "",
        loggedIn: auth.loggedIn(),
        isRootComponent: true,
        dark: false,
        drawer: window.innerWidth > 960,
        fixed: false,
        items: [
          {
            icon: "thumbs_up_down",
            title: "PDF проверки",
            vertical: "Order",
            link: "PDFChecks"
          },
          {
            icon: "mail",
            title: "Почта",
            vertical: "Order",
            link: "MailList"
          },
          {
            icon: "sell",
            title: "Ордера",
            vertical: "Order",
            link: "Orders"
          },
          {
            icon: "dashboard",
            title: "Статистика",
            vertical: "Dashboard",
            link: "Dashboard"
          },
          {
            icon: "perm_identity",
            title: "Сотрудники",
            vertical: "Workers",
            link: "Workers"
          },
//          {
//            icon: "extension",
//            title: "Расширение",
//            vertical: "Extention",
//            link: "Extention"
//          },
          {
            icon: "account_box",
            title: "Контрагенты",
            vertical: "Contragent",
            link: "Contragents"
          },
          {
            icon: "bubble_chart",
            title: "Blacklist",
            vertical: "Blacklist",
            link: "BlackList"
          },
          {
            icon: "help",
            title: "Помощь",
            vertical: "About",
            link: "About"
          }
        ],
        userMenus: [
          {
            icon: "bubble_chart",
            title: "Logout",
            link: "/logout"
          },
        ],
        sides: ["sell", "buy"],
        miniVariant: false,
        right: true,
        rightDrawer: false,
        menuItem: "Orders",
        from: "",
        until: "",
        fromRu: "",
        untilRu: "",
        fromTime: "00:00",
        untilTime: "23:59",
        worker: "",
        account: "",
        bank: "",
        side: "",
        usdtrub_color: 'black',
      };
    },
    created () {
      const cookiestring = RegExp("dark=[^;]+").exec(document.cookie);
      this.dark = decodeURIComponent(cookiestring ? cookiestring.toString().replace(/^[^=]+./, "") : "") === 'true';
      auth.onChange = loggedIn => {
        console.log("loggedIn", loggedIn);
        this.loggedIn = loggedIn;
      };
      //  [App.vue specific] When App.vue is first loaded start the progress bar
      this.$Progress.start();
      //  hook the progress bar to start before we move router-view
      this.$router.beforeEach((to, from, next) => {
        //  does the page we want to go to have a meta.progress object
        if (to.meta.progress !== undefined) {
          let meta = to.meta.progress;
          // parse meta tags
          this.$Progress.parseMeta(meta);
        }
        //  start the progress bar
        this.$Progress.start();
        //  continue to next page
        next();
      });
      //  hook the progress bar to finish after we've finished moving router-view
      this.$router.afterEach((to, from) => {
        if (to.name !== "ErrorPage") {
          this.menuItem = to.name;
        }
        //  finish the progress bar
        // this.$Progress.finish();
      });
      Store.dispatch("filters/flush");
    },
    computed: {
      ...mapState(
        "orders", {
            resume: "resume",
      }),
      ...mapState(
        "user", {
            user: "user"
      }),
      ...mapState(
        "filters", {
            banks: "banks",
            workers: "workers",
            accounts: "accounts",
      }),
      ...mapState(
        "inform", {
            account_info: "account"
      }),
      auth () {
        return auth;
      },
      activeMenuItem() {
        return this.menuItem;
      },
    },
    methods: {
      darkMode() {
        this.dark = !this.dark;
        document.cookie = "dark=" + this.dark + '; Path=/; Expires=Thu, 01 Jan 2070 00:00:01 GMT;';
      },
      showFilters() {
        return ['/pdfchecks', '/dashboard', '/mail', '/orders'].includes(this.$route.path);
      },
      clickMenu(item) {
        this.menuItem = item.title;
        this.$router.push({
          name: item.link
        });
      },
    },
    watch: {
      fromTime() {
        Store.dispatch("filters/setFromTime", this.fromTime);
      },
      untilTime() {
        Store.dispatch("filters/setUntilTime", this.untilTime);
      },
      from() {
        this.fromRu = new Date(this.from).toLocaleString("ru", { year: 'numeric', month: 'numeric', day: 'numeric' });
        Store.dispatch("filters/setFromDate", this.from);
      },
      until() {
        this.untilRu = new Date(this.until).toLocaleString("ru", { year: 'numeric', month: 'numeric', day: 'numeric' });
        Store.dispatch("filters/setUntilDate", this.until);
      },
      worker() {
        const id = this.worker ? this.worker.id : null;
        Store.dispatch("filters/setWorker", id);
      },
      account() {
        const id = this.account ? this.account.bybit_id : null;
        Store.dispatch("filters/setAccount", id);
      },
      bank() {
        const id = this.bank ? this.bank.id : null;
        Store.dispatch("filters/setBank", id);
      },

      inform(){
        if (this.lastinform !== [] && this.inform.usdt_rub > this.lastinform.usdt_rub){
          this.usdtrub_color = 'green';
        } else if (this.lastinform !== [] && this.inform.usdt_rub < this.lastinform.usdt_rub){
          this.usdtrub_color = 'red';
        } else {
          this.usdtrub_color = 'black';
        }
      }
    },
    mounted () {
      var options = {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
      };
      this.from = new Date().toISOString().substr(0, 10);
      this.until = new Date().toISOString().substr(0, 10);
      Store.dispatch("filters/setFromDate", this.fromRu);
      Store.dispatch("filters/setUntilDate", this.untilRu);
      Store.dispatch("filters/setFromTime", this.fromTime);
      Store.dispatch("filters/setUntilTime", this.untilTime);
      Store.dispatch("filters/setWorker", this.worker);
      Store.dispatch("filters/setAccount", this.account);

      Store.dispatch("filters/getBanks", { } );
      Store.dispatch("filters/getWorkers", { } );
      Store.dispatch("filters/getAccounts", { } );
      Store.dispatch("inform/getInfo", { } );
      setInterval(() => {
        Store.dispatch("inform/getInfo", { } );
      }, 60000);
    }
  };

</script>

<style lang="stylus">
 @import './stylus/main';
</style>
<style scoped>
  .right-input >>> input {
    width: 110px;
  }
  .select-box {
    max-width: 110px;
  }
  .info-table {
    font-size: 18px;
  }
  .info-label {
    vertical-align: text-top; 
    font-size: 10px;
  }
  .info-sum {
    font-size: 18px;
    text-align: right;
  }
  .info-sell {
    color: red;
  }
  .info-buy {
    color: green;
  }
</style>



// WEBPACK FOOTER //
// App.vue?6be71972